// SHIM — codice spostato in src/shared/mixins/calendario.js
export { default } from '@shared/mixins/calendario.js';
